import { userRoles } from "../constants";
import { baseRouteMaker, routes } from "../constants/routeConsts";
import i18n from "../i18n/i18n";
import useLocalStorage from "../hooks/useLocalStorage";
import { appConfig } from "../constants/config/appConfig";
import { useEffect } from "react";
import {
  FaqIcon,
  LanguagesIcon,
  LogoutIcon,
  YourProfileIcon,
} from "../assets/svg";

export const useDrawerMenuUtils = (t) => {
  /* local storage dependencies */
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);
  /* local storage dependencies */

  let tempMenuGroup = [];
  /* menuItemYourProfile */
  const menuItemYourProfile = {
    label: t("ProfileMenuNames.YourProfile"),
    icon: YourProfileIcon,
    path:
      userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN
        ? baseRouteMaker(routes.UPDATE_PROFILE_SETUP)
        : baseRouteMaker(routes.PROFILE_SETTINGS),
  };

  if (
    userSession &&
    userSession.userRole !== userRoles.SUPER_ADMIN &&
    userSession.userRole !== userRoles.SUPER_ADMIN_ROLES.ACCOUNTANT &&
    userSession.userRole !== userRoles.SUPER_ADMIN_ROLES.CUSTOMER_SUPPORT
  ) {
    tempMenuGroup.push(menuItemYourProfile);
  }
  /* menuItemYourProfile */

  /* menuItemLanguages */
  const menuItemLanguages = {
    label: t("ProfileMenuNames.Languages"),
    icon: LanguagesIcon,
    path: "",
  };
  tempMenuGroup.push(menuItemLanguages);
  /* menuItemLanguages */

  /* menuItemLogout */
  const menuItemLogout = {
    label: t("ProfileMenuNames.Logout"),
    icon: LogoutIcon,
    path: baseRouteMaker(routes.SIGN_IN),
  };
  tempMenuGroup.push(menuItemLogout);
  /* menuItemLogout */

  return tempMenuGroup;
};
